// Up to two characters for an avatar: a guest's code ("Guest 4F2A" → "4F"), otherwise the first letter.
export function getInitials(name: string | undefined, isGuest: boolean): string {
    const trimmed = name?.trim();
    if (!trimmed) return "?";
    const words = trimmed.split(/\s+/);
    return isGuest && words.length > 1 ? words[words.length - 1].slice(0, 2).toUpperCase() : trimmed[0].toUpperCase();
}
